import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API_URL from '../../apiConfig';

function Dashboard(){
    const [admin, setAdmin] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        // Récupérer la session
        fetch(`${API_URL}/admin/session`, {
        credentials: 'include',
        method: "POST"
        })
        .then(res => {
            if (!res.ok) throw new Error('Non connecté');
            return res.json();
        })
        .then(data => setAdmin(data.admin))
        .catch(() => {
            // Si pas connecté → retour à login
            navigate('/');
        });
    }, [navigate]);

    if (!admin) {
        navigate('/');
        return null;
    }
    return(
        <div className="w-100 min-vh-100 bg-lamp-gradient d-flex align-items-center justify-content-center p-3">
            <div className="card-custom text-center animate__animated animate__zoomIn" style={{ maxWidth: '600px', backgroundColor: '#ffffff' }}>
                <div className="bg-lamp p-5 mb-2">
                    <div className="mx-auto bg-white bg-opacity-20 rounded-circle d-flex align-items-center justify-content-center mb-4 border border-2 border-white shadow-sm overflow-hidden" style={{ width: '120px', height: '120px' }}>
                        {admin.linkImg ? (
                            <img src={admin.linkImg} alt="profil" className="w-100 h-100 object-cover" />
                        ) : (
                            <span style={{ fontSize: '3.5rem' }}>👋</span>
                        )}
                    </div>
                    <h1 className="text-white fw-bold mb-0 outfit">Salut, {admin.prenom} {admin.nom} !</h1>
                </div>
                
                <div className="p-5">
                    <p className="lead text-dark fw-medium mb-5 px-lg-4">
                        Bienvenue dans votre espace d'administration sécurisé. Tout est prêt pour vos nouvelles publications.
                    </p>

                    <button 
                        onClick={() => navigate('/connexion-admin/dashboard')} 
                        className="btn-primary-custom px-5 py-3 d-inline-flex align-items-center justify-content-center gap-3 w-100"
                    >
                        ACCÉDER AU DASHBOARD
                        <i className="bi bi-arrow-right-short fs-4"></i>
                    </button>
                    
                    <p className="mt-4 text-muted extra-small">
                        LAMP Edification &copy; {new Date().getFullYear()}
                    </p>
                </div>
            </div>
        </div>
    );

}


export default Dashboard;